export const ACCEPTED_COMPANY_PROOF = "image/jpeg,image/png,image/webp,application/pdf";
export function companyProofError(file: File | null) {
  if (!file) return "Choose a supporting registration document.";
  if (!file.size || file.size > 25 * 1024 * 1024) return "Choose a document between 1 byte and 25 MB.";
  if (!ACCEPTED_COMPANY_PROOF.split(",").includes(file.type)) return "Use a JPEG, PNG, WebP or PDF document.";
  return null;
}
